import { inject } from '@angular/core';
import { ActivityEntityName, EntityQueueCommandIds, EntityQueueNameExistsRequest } from '@jms/model';
import { SettingsPanelValidationError } from '@workbuddy/ui/v2/blocks/settings.panel';
import { EntityDataService } from '@workbuddy/services/entities/entity.data.service';

export function injectQueueNameUniqueChecker(): (name: string, excludeQueueId?: string) => Promise<boolean> {

  const entityData = inject(EntityDataService);

  return async (name, excludeQueueId) => {

    const request: EntityQueueNameExistsRequest = { name, excludeQueueId };
    const duplicate = await entityData.executeCommand<boolean>(ActivityEntityName.EntityQueue, EntityQueueCommandIds.NameExists, request);
    return !duplicate;
  };
}

export function nameUnique(isUnique: (name: string) => Promise<boolean>) {

  let lastChecked: string | null = null;
  let lastResult: SettingsPanelValidationError[] | null = null;

  return async (values: Record<string, unknown>): Promise<SettingsPanelValidationError[] | null> => {

    const name = String(values['name'] ?? '').trim();
    if (!name) return null;

    if (name === lastChecked) return lastResult;

    lastChecked = name;
    lastResult = (await isUnique(name))
      ? null
      : [{ field: 'name', unique: true }];
    return lastResult;
  };
}
